import axios from "axios";

export const urlApi = 'https://imobiliaria-back.vercel.app';

const Api = axios.create({
    baseURL: 'https://imobiliaria-back.vercel.app',
});
 
export default Api;